import { Pipe, PipeTransform } from "@angular/core";
import { CurrencyPipe } from '@angular/common';
import { AppConstants } from "../../app.constants";

@Pipe({ name: 'tnCurrency' })
export class TNCurrencyPipe implements PipeTransform {
    currency: string;
    locale: string;

    constructor(private currencyPipe: CurrencyPipe) {
        this.currency = 'USD';
        this.locale = 'en-US';
    }

    transform(value: string) {
        const val = value !== undefined ? value : 0;
        let retVal = this.currencyPipe.transform(
            val,
            this.currency,
            AppConstants.currencyIndicator,
            AppConstants.digitsInfo,
            this.locale
        );
        retVal = retVal.substring(0, retVal.indexOf('.')+3);
        return retVal;
    }
}